// === Shopify BGN⇄EUR Fixed-Rate Currency Converter v1.2 ===
(function (window, document) {
  'use strict';

  if (window.BgnEurLiveConverter) return;

  const DEFAULTS = {
    // no more apiURL
    fallbackRate: 1.95583, // always 1 EUR = 1.95583 BGN
    selectors: [
      '.price',
      '[class*="price"]',
      '.amount',
      '[class*="amount"]',
      '.cart__price',
      'ins',
      '.cart__price span',
    ],
    batchTime: 50,
    idleDelay: 200,
    debug: false,
    localeBG: 'bg-BG',
    localeEU: 'en-US',
    decimals: 2,
  };

  let cfg, rateEURtoBGN, rateBGNtoEUR, observer, enabled;
  const stats = {converted: 0, skipped: 0, errors: 0, lastBatch: 0};
  const seen = new WeakSet();

  function log(...args) {
    cfg.debug && console.debug('[BGN⇄EUR]', ...args);
  }

  function initConfig(userCfg = {}) {
    cfg = {...DEFAULTS, ...userCfg};
  }

  // Set fixed rates synchronously
  function setFixedRate() {
    rateEURtoBGN = cfg.fallbackRate;
    rateBGNtoEUR = 1 / rateEURtoBGN;
    log('Fixed rate set:', rateEURtoBGN);
  }

  function extractNumber(str) {
    const cleaned = str.replace(/[^\d,.-]/g, '').trim();
    if (cleaned.includes(',') && cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
      return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
    }
    return parseFloat(cleaned.replace(/,/g, ''));
  }

  function format(num, locale) {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: cfg.decimals,
      maximumFractionDigits: cfg.decimals,
    }).format(num);
  }

  const moneyRE = new RegExp(
    [
      '(?<!\\()',
      '([0-9]{1,3}(?:[.,][0-9]{3})*(?:[.,][0-9]{1,2})?)',
      '\\s*',
      '([€]|лв\\.?|BGN|EUR)',
      '(?![^()]*\\))',
    ].join(''),
    'gi'
  );

  function alreadyConverted(text) {
    return /\([^)]*(?:€|лв)[^)]*\)/.test(text);
  }

  function replacer(match, amt, sym) {
    const n = extractNumber(match);
    if (isNaN(n) || n <= 0) {
      stats.skipped++;
      return match;
    }
    let converted, label;
    if (/^(?:лв|BGN)$/i.test(sym)) {
      converted = n * rateBGNtoEUR;
      label = '€';
    } else {
      converted = n * rateEURtoBGN;
      label = 'лв';
    }
    const formatted = format(converted, label === '€' ? cfg.localeEU : cfg.localeBG);
    stats.converted++;
    // wrap the entire output in a .converted span
    return `<span class="converted">${match} <span class="conversion-pipe">|</span> ${formatted} ${label}</span>`;
  }

  function processBatch(nodes) {
    const start = performance.now();
    let processed = 0;

    while (nodes.length && performance.now() - start < cfg.batchTime) {
      const node = nodes.shift();
      if (seen.has(node)) continue;

      const parentEl = node.parentNode;
      if (parentEl && parentEl.closest('.old-price, .product__price--strike')) {
        stats.skipped++;
        seen.add(node);
        continue;
      }

      const txt = node.textContent;
      if (txt && !alreadyConverted(txt) && moneyRE.test(txt)) {
        try {
          // Build HTML string with our <span> wrapper
          const html = txt.replace(moneyRE, replacer);

          // Create a DocumentFragment from the HTML
          const range = document.createRange();
          range.selectNodeContents(node);
          const frag = range.createContextualFragment(html);

          // Replace the text node with the HTML fragment
          node.parentNode.replaceChild(frag, node);

          seen.add(node);
          processed++;
        } catch (e) {
          stats.errors++;
          log('Conversion error:', e);
        }
      }
    }

    stats.lastBatch = performance.now() - start;
    return processed;
  }

  function collectTextNodes() {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          // skip empty or struck-through text
          if (!node.nodeValue.trim() || node.parentElement.tagName.toLowerCase() === 'del') {
            return NodeFilter.FILTER_REJECT;
          }
          // skip anything inside our conversion wrapper or pipe
          if (node.parentElement.closest('.converted, .conversion-pipe')) {
            return NodeFilter.FILTER_REJECT;
          }
          // only accept text under one of our selectors
          return node.parentNode.closest(cfg.selectors.join(',')) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        },
      },
      false
    );

    const out = [];
    let n;
    while ((n = walker.nextNode())) out.push(n);
    return out;
  }

  function scanAndConvert() {
    if (!enabled) return;
    const nodes = collectTextNodes();
    if (!nodes.length) return;
    (function run() {
      if (!nodes.length) return;
      processBatch(nodes);
      if (nodes.length) {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(run, {timeout: cfg.batchTime});
        } else {
          setTimeout(run, 0);
        }
      }
    })();
  }

  function startObserver() {
    if (!('MutationObserver' in window)) return;
    observer = new MutationObserver(() => {
      clearTimeout(observer._timer);
      observer._timer = setTimeout(scanAndConvert, cfg.idleDelay);
    });
    observer.observe(document.body, {childList: true, subtree: true});
  }

  const api = {
    init(options) {
      initConfig(options);
      enabled = true;
      setFixedRate();
      scanAndConvert();
      startObserver();
      log('Converter initialized (fixed rate).');
    },
    pause() {
      enabled = false;
    },
    resume() {
      enabled = true;
      scanAndConvert();
    },
    updateRate(newRate) {
      // still allow manual override if ever needed
      cfg.fallbackRate = newRate;
      setFixedRate();
    },
    resetStats() {
      Object.assign(stats, {converted: 0, skipped: 0, errors: 0, lastBatch: 0});
    },
    getStats() {
      return {...stats};
    },
    disable() {
      this.pause();
      if (observer) observer.disconnect();
      log('Converter disabled.');
    },
  };

  window.BgnEurLiveConverter = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => api.init(), {once: true});
  } else {
    api.init();
  }
})(window, document);
